exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.closual_reson[data-v-4f7798b6] {\n  padding: 3px 10px;\n  border-radius: 10px;\n  color: rgba(46, 3, 140, 0.8);\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/containers/ticket/components/ticket-chat-message-request-quote-item/styles.scss"],"names":[],"mappings":";AAAA;EAEE,kBAAiB;EACjB,oBAAmB;EAGnB,6BAA4B;CAC7B","file":"styles.scss","sourcesContent":[".closual_reson {\n\n  padding: 3px 10px;\n  border-radius: 10px;\n\n\n  color: rgba(46, 3, 140, 0.8);\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f7798b6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/containers/ticket/components/ticket-chat-message-request-quote-item/styles.scss
// module id = VqOn
// module chunks = 0